<div class="input">
    <i class="icon-minus" (click)="valueMinus()"></i>
    <input type="text" value="0" [(ngModel)]="value" (input)="onInput(input.value)" (blur)="onBlur()" #input class="form-control" />
    <i class="icon-add" (click)="valuePlus()"></i>
</div>
